<template>
  <Modal
    actions
    name="DELETE_ALL_APPOINTMENT_FILES"
    :title="$t('appointment.label.deleteAllFiles')"
  >
    <template v-slot:body>
      <h3 class="red--text">
        {{ $t('upload.delete.title') }}
      </h3>
      <p>
        {{ $t('upload.delete.deleteAll') }}
      </p>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isAppointmentFilesDeleting"
        elevation="0"
        color="grey darken-1"
        text
      >
        {{ $t('deleteModal.buttons.cancel') }}
      </v-btn>
      <v-btn
        @click="deleteAllFiles"
        :loading="isAppointmentFilesDeleting"
        elevation="0"
        class="ml-5"
        color="red"
        dark
      >
        {{ $t('deleteModal.buttons.deleteAllFiles') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ModalAdminAppointmentDeleteAllFiles',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['adminAppointmentFiles', 'isAppointmentFilesDeleting']),
  },

  methods: {
    ...mapMutations([
      'closeAllModals',
      'setAdminAppointmentFilesToDelete',
      'setIsAppointmentFilesDeleting',
    ]),
    ...mapActions(['deleteAppointmentFileAsAdmin']),

    deleteAllFiles() {
      Promise.resolve(this.adminAppointmentFiles)
        .then((files) => {
          this.setAdminAppointmentFilesToDelete(files)
        })
        .then(() => {
          this.deleteAppointmentFileAsAdmin()
        })
    },
  },
}
</script>
